import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import HTML from "@client/controls/HTML/component";
import * as React from "react";

export type HTMLProps = RootContainerProps & {
  description: string;
};

export default (props: HTMLProps) => (
  <Container {...getContainerProps(props)}>
    <HTML html={props.description} />
  </Container>
);
